import HttpClient from "../../helpers/HttpClient"
import RowCustomStatus, { RowCustomStatusAttributes, RowCustomStatusDto } from "./RowCustomStatus"
import { HttpError, isError } from "../../helpers/Error"
import {RowCustomStatusAttributesDto, RowCustomStatusRankUpdateDto} from "./RowCustomStatusTypes"

class RowCustomStatusService {
    httpClient: HttpClient<RowCustomStatus,
        RowCustomStatusDto> = new HttpClient<RowCustomStatus, RowCustomStatusDto>(RowCustomStatus)

    async GetAll(): Promise<RowCustomStatus[] | HttpError> {
        const res = await this.httpClient.get("/custom-row-statuses")
        if (!isError(res)) {
            return res as RowCustomStatus[]
        }
        return res
    }

    async Create(dto: RowCustomStatusAttributes) {
        return await this.httpClient.post("/custom-row-statuses", dto)
    }

    async Update(id: string, dto: RowCustomStatusAttributesDto) {
        return await this.httpClient.patch(`/custom-row-statuses/${id}`, dto)
    }

    async Delete(id: string): Promise<RowCustomStatus | HttpError> {
        const res = this.httpClient.delete(`/custom-row-statuses/${id}`)
        if (!isError(res)) {
            return res
        }
        return res
    }

    async UpdateRanks(dto: RowCustomStatusRankUpdateDto) {
        return this.httpClient.patch("/custom-row-statuses/ranks/order", dto)
    }

}

const instance = new RowCustomStatusService()
export default instance


// WEBPACK FOOTER //
// ./src/state/pricing/rowcustomstatus/RowCustomStatusService.ts